export { default as noneIcon } from "./none.png"
export { default as bingRoadIcon } from "./bing_road.png"
export { default as bingAerialIcon } from "./bing_aerial.png"
export { default as bingAerialLabelsIcon } from "./bing_aerial_labels.png"
export { default as osmIcon } from "./osm.png"
export { default as usgsImagery } from "./usgs_imagery.png"
export { default as usgsTopo } from "./usgs_topo.png"
export { default as usgsHydro } from "./usgs_hydro.png"
export { default as usgsShaded } from "./usgs_shaded.png"
